export default __webpack_public_path__ + "static/media/shoes5.8857de3e.jpg";